import { LoginPage } from '@/pages/Login/LoginPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/login/')({
  component: LoginPage,
  head: () => ({
    meta: [
      {
        title: 'Login - Enablar',
      },
      {
        name: 'description',
        content: 'Login to your Enablar account.',
      },
    ],
  }),
})
